var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E8E",
    fillRule: "nonzero",
    d: "M16.44 0H2.56C1.146 0 0 1.086 0 2.426v13.148C0 16.914 1.146 18 2.56 18h6.846l.011-6.432H7.653a.406.406 0 0 1-.416-.393L7.23 9.102c-.001-.219.185-.396.416-.396h1.76V6.702c0-2.325 1.5-3.59 3.689-3.59h1.796c.23 0 .416.176.416.394v1.748a.406.406 0 0 1-.416.394h-1.102c-1.19 0-1.421.537-1.421 1.323v1.735h2.616c.25 0 .442.206.413.44l-.26 2.074a.409.409 0 0 1-.413.348h-2.345L12.367 18h4.073c1.414 0 2.56-1.086 2.56-2.425V2.425C19 1.086 17.854 0 16.44 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3c57ca3d14024101899113b2694cb7cf.svg";
export { ForwardRef as ReactComponent };